import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../Global/loader.js'
import { FaPlus } from 'react-icons/fa'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import clientDevicesList from '../../../API/Admin/GetClientDevicesList'
import { AiFillEdit, AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deleteNaplatniUredaj from '../../../API/Admin/DeleteNaplatniUredaj'
import { Button } from 'react-bootstrap'
import CreateNapUredaj from './CreateNapUredaj.js'
import UpdateNapUredaj from './UpdateNapUredaj.js'
import { RiLockPasswordLine } from 'react-icons/ri'
import getNewOTP from '../../../API/Admin/GetNewOTP'
import { BsBackspaceFill } from 'react-icons/bs'
import toggleActiveDevice from '../../../API/Admin/PutChangeStatus'

class NapUredaj extends React.Component {
  
    state={
        loading: true,
        create: false,
        showDeleteModal: false,     
        uuidForDelete: "",  
        showOneNapUredaj: false,
        premesisList: [],
        
        customStyles: {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                //marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                color: 'red'
            }
        },

        columns:[{
            dataField: 'label',
            text: 'Naziv',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"}            
          }, {
            dataField: 'businessPremises',
            text: 'Poslovni Prostor',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"}   
        }, {
            dataField: 'isuNumber',
            text: 'ISU',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"}   
        }, {
          dataField: 'tid',
          text: 'TID',
          style: {wordWrap: "break-word"} ,
          headerStyle: {wordWrap: "break-word"}   
        }, {
            dataField: 'enabled',
            text: 'Aktivan',
            headerStyle: {wordWrap: "break-word"},    
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <span style={{ color: row.enabled ? "green": "red"}}>
                        <strong>
                            { !row.enabled ?  'Ne' : 'Da' }
                        </strong>
                    </span>
                </div>
            );
            }
        }, {
            dataField: 'ecommerce',
            text: 'E-commerce',
            headerStyle: {wordWrap: "break-word"},    
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} style={{wordWrap: "break-word"}}>
                        <span style={{ color: row.ecommerce ? "green": "red"}}>
                            <strong>
                                { !row.ecommerce ?  'Ne' : 'Da' }
                            </strong>
                        </span>
                    </div>
                );
            }
        }, {
            dataField: '',
            isDummyField: true,
            text: '',
            headerStyle: (colum, colIndex) => {
                return { width: '22.5em' };
            },
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    {!row.enabled ?
                     <div 
                        className="btn btn-success" 
                        onClick={() =>this.activateDevice(row)} 
                        style={{marginRight: "10px", marginBottom: "10px", fontSize: "13px"}}
                    > 
                        <AiOutlinePlusCircle style={{verticalAlign: "text-bottom"}} /> Aktiviraj
                    </div> 
                    :
                    <div 
                        className="btn btn-danger" 
                        onClick={() =>this.activateDevice(row)} 
                        style={{marginRight: "10px", marginBottom: "10px", fontSize: "13px"}}
                    > 
                        <AiOutlineMinusCircle style={{verticalAlign: "text-bottom"}} /> Deaktiviraj
                    </div>
                    }

                    <div 
                        className="btn btn-info" 
                        id={row.uuid} 
                        onClick={() =>this.getNewOTP(row)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <RiLockPasswordLine /> OTP
                    </div> 

                    <div 
                        className="btn btn-warning" 
                        id={row.uuid} 
                        onClick={() =>this.seeDetails(row)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <AiFillEdit /> Detalji 
                    </div> 

                    <div 
                        className="btn btn-danger"
                        id={row.uuid}
                        onClick={() => this.showDeleteModal(row.uuid)}
                        style={{marginBottom: "10px", fontSize: "13px"}}
                    >
                        <RiDeleteBin5Line /> Izbriši
                    </div> 
                   
                </div>
                
              );
            }
        }]        
        
    }

    componentDidMount = async () => {
        this.setState({loading: true})  
        
        let lista = await clientDevicesList(this.props.oneClientInfo.uuid)
        if(lista.data.length > 0){
            this.props.mapState("ADMIN_MAP_NAP_URED_LIST", lista.data)
        }
        else{
            this.props.mapState("ADMIN_MAP_NAP_URED_LIST", [])
            /*
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom dohvata Naplatnih Uređaja, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
            */
        }
        
        this.setState({
            loading: false
        })
        
    }

    handleChange(e){      
        this.setState({
            [e.target.id]: e.target.value
        })        
    }

    toggleCreate(){
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){
        this.setState({
            showOneNapUredaj: !this.state.showOneNapUredaj
        })
        this.componentDidMount()
    }

    showDeleteModal = uuid => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid
        });
    };

    activateDevice = async (row) => {
        this.setState({
            loading: true
        })

        await toggleActiveDevice(row)

        this.componentDidMount()

        this.setState({
            loading: false
        })
    }

    confirmDelete = async () => {
        let deletedPosProstor = await deleteNaplatniUredaj(this.props.oneClientInfo.uuid, this.state.uuidForDelete)   
        if(deletedPosProstor.data.operationResult !== "SUCCESS"){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom brisanja Naplatnog Uređaja, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: "Uspješno!",
                message: "Brisanje naplatnog uređaja je izvršeno.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("ADMIN_MAP_ONE_NAPLATNI_UREDAJ", data)
        await this.setState({
            showOneNapUredaj: !this.state.showOneNapUredaj
        })
    }
/*
    backFromEdit = async () =>{
        await this.setState({
            showOneNapUredaj: !this.state.showOneNapUredaj
        })
    }
*/
    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_NAPLATNI_UREDAJ_DETAILS", e.target) 
    }

    getNewOTP = async (data) => {
        this.setState({
            loading: true
        })

        const newOTP = await getNewOTP(this.props.oneClientInfo.uuid, data.uuid)

        alert("Novi OTP: " + newOTP.data.data[0].otp)

        this.setState({
            loading: false
        })
    }

    goBack(){
        window.location = "#/Admin/client/"
    }

   
    render(){  
        const { loading, create, showOneNapUredaj } = this.state 

    return (
        <>
        {loading ? 
            <Loader />
        :
            <>
                {showOneNapUredaj? 
                    <UpdateNapUredaj goBack={() => this.backFromEdit()} />
                :
                create ? 
                    <CreateNapUredaj goBack={() => this.backFromCreate()} />
                :
                    <>

                        <div style={{padding:"20px", float: "right"}}>
                            <div className="btn btn-success" style={{fontSize: "16px"}} onClick={() => this.toggleCreate()}>
                                <FaPlus size={20} /> <span style={{verticalAlign: "middle"}} >Kreiraj</span>
                            </div>
                        </div>
                
                        <BootstrapTable
                            keyField="uuid" 
                            data={ this.props.napUredajiList } 
                            columns={ this.state.columns }   
                            bodyStyle={{wordBreak: 'break-word'} }                    
                        />
                
                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                            contentLabel="Example Modal"
                        >
            
                            <h1 style={{padding:"20px"}}><strong>Upozorenje!</strong></h1>
                        
                            <div className="" style={{padding: "20px"}}>
                                Brisanjem Naplatnog uređaja obrisat će se i ostali podaci koji su vezani uz njega.                                
                            </div>

                            <div className="row">
                                <div className="col col-sm-6">
                                    <Button variant="primary" size="lg" onClick={() => this.showDeleteModal("")}>Zatvori</Button>
                                </div>
                                <div className="col col-sm-6">
                                    <Button variant="danger" size="lg" onClick={() => this.confirmDelete()}> IZBRIŠI</Button>
                                </div>                
                            </div>
                    
                        </Modal> 
                        <div 
                            className="btn btn-default" 
                            style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => this.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>Nazad</strong>                    
                        </div> 
                    </>
                }   
                             
            </>
            
        }
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro,
        napUredajiList: state.adminClient.napUredajiList
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(NapUredaj);


